import React from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import { styled } from '@linaria/react';
import BackToTopButton from './BackToTopButton';
import { PaginationFooter } from './PaginationFooter';
import useOnFooterView from './useOnFooterView';
import usePagination, { PaginationState } from './usePagination';
const PaginationFooterWrapper = /*#__PURE__*/styled('div')({
  name: "PaginationFooterWrapper",
  class: "p12gwtiw",
  propsAsIs: false
});
export const Pagination: React.FC = ({
  children
}) => {
  const {
    currentPageNumber,
    paginationState,
    onScrollToTop,
    onLoadMore
  } = usePagination();
  const {
    isFooterVisibilitySensorEnabled,
    onFooterView
  } = useOnFooterView();
  return <>
      {children}

      <VisibilitySensor
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // It will be fixed once this PR, https://github.com/joshwnj/react-visibility-sensor/pull/180, has been merged
    partialVisibility="bottom" active={isFooterVisibilitySensorEnabled} onChange={isVisible => isVisible && onFooterView()}>
        <PaginationFooterWrapper>
          <PaginationFooter paginationState={paginationState} onLoadMore={onLoadMore} />
        </PaginationFooterWrapper>
      </VisibilitySensor>

      {paginationState !== PaginationState.Disabled && <BackToTopButton enabled={currentPageNumber > 1} onClick={onScrollToTop} />}
    </>;
};

require("./index.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");